// ** Next Import
import Link from 'next/link'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled, useTheme } from '@mui/material/styles'
import { useAuth } from 'src/hooks/useAuth'
import { AuthContext } from 'src/context/AuthContext'

//import Autocomplete from 'src/layouts/components/Autocomplete'
// import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
// import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
// import LanguageDropdown from 'src/@core/layouts/components/shared-components/LanguageDropdown'
// import NotificationDropdown from 'src/@core/layouts/components/shared-components/NotificationDropdown'
// import ShortcutsDropdown from 'src/@core/layouts/components/shared-components/ShortcutsDropdown'

// import themeConfig from 'src/configs/themeConfig'

const LinkStyled = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  marginRight: theme.spacing(8)
}))

const AppBarContent = props => {
  // ** Props
  const { appBarContent: userAppBarContent, appBarBranding: userAppBarBranding, navigationContent } = props

  // ** Hooks
  useTheme()

  const { logoUrlFromSettings } = useAuth(AuthContext)

  return (
    <Box sx={{ width: '100%', alignSelf: 'stretch', display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
      <Box
        className='logo-area'
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          alignSelf: 'stretch',
          mb: '-1px',
          backgroundColor: '#ffffff',
          pl: 6,
          pr: 8,
          '@media (max-width: 1600px)': {
            pl: 3,
            pr: 5
          },
          '& img': {
            maxHeight: 36,
            maxWidth: 160,
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            '@media (max-width: 1600px)': { maxWidth: 120 }
          },
          clipPath: 'polygon(0 0, 100% 0, calc(100% - 32px) 100%, 0 100%)'
        }}
      >
        {userAppBarBranding ? (
          userAppBarBranding(props)
        ) : (
          <LinkStyled href='/'>
            <img src={logoUrlFromSettings ? logoUrlFromSettings : '/images/cxpify_PNG.png'} alt='TotientCXP Logo' />
          </LinkStyled>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          minWidth: 0,
          flexWrap: 'nowrap',
          // Includes the slot of the removed Home icon so the nav items keep their position
          pl: 23,
          '@media (max-width: 1600px)': {
            pl: 18
          }
        }}
      >
        {navigationContent}
      </Box>
      {userAppBarContent ? userAppBarContent(props) : null}
    </Box>
  )
}

export default AppBarContent
